import { FC } from "react";

import Image from "next/legacy/image";
import isAfter from "date-fns/isAfter";

import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import { Tier } from "sections/christmasPage/Tier.interface";

import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Card from "components/Card";
import CustomButton from "components/CustomButton";

import { TIERS } from "services/gifts/Tiers";

import styles from "./styles";

const tiers: Tier[] = [
  {
    title: "Regular Gift",
    description:
      "Christmas Gift available for everyone. Claim a gift for your metaverse wearable with the possibility to redeem the corresponding physical item!",
    imagePath: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/christmasPage/regular-box.gif`,
    rewards: () => <>One from a few regular metaverse wearables.</>,
    requirements: "Meet some social media activities to get best items.",
    type: TIERS.BRONZE,
  },
  {
    title: "NFT Holder Gift",
    description:
      "Hold any NFT (ERC-721) on the Ethereum network to get a metaverse wearable. Together with it you are able to redeem your physical item too!",
    imagePath: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/christmasPage/premium-box.gif`,
    rewards: () => <>One from a few exclusive metaverse wearable</>,
    requirements:
      "Hold any NFT on the Ethereum mainnet and meet some social media activities.",
    type: TIERS.SILVER,
  },
  {
    title: "NFT Degen Gift",
    description:
      "Hold any NFT (ERC-721) on the Ethereum network for at least 5 months to get a metaverse wearable. That’s not all! Claim the metaverse wearable, fill a form and get a chance to draw a special physical item with your favourite NFT on it!\n",
    imagePath: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/christmasPage/unique-box.gif`,
    rewards: () => (
      <>
        One from a few exclusive metaverse wearable and special NFT redeemable
        for physical item to win
      </>
    ),
    requirements:
      "Hold any NFT on Ethereum mainnet for at least 5 months and meet some social media activities.",
    type: TIERS.GOLD,
  },
];

const Tiers: FC = () => {
  return (
    <GridContainer mt={6} spacing={4} justifyContent="center">
      {tiers.map((tier, key) => (
        <GridItem
          key={`tier-${key}`}
          sm={12}
          md={6}
          lg={4}
          position="relative"
          sx={{ mt: { xs: 5, lg: 0 } }}
        >
          <Card sx={styles.card}>
            <Box width="100%" display="flex" flexDirection="column" pb={4}>
              <Box justifyContent="center" display="flex" mb={3}>
                <Image src={tier.imagePath} width={150} height={180} />
              </Box>
              <Typography variant="h3" component="h3">
                {tier.title}
              </Typography>
              <Typography variant="subtitle1" mt={2}>
                {tier.description}
              </Typography>
              <Typography variant="subtitle1" mt={2}>
                <strong>Requirements: </strong>
                {tier.requirements}
              </Typography>
              <Typography variant="subtitle1" mt={2}>
                <strong>Rewards pool: </strong>
                {tier.rewards()}
              </Typography>
            </Box>
          </Card>
          <CustomButton disableRipple disabled={true} sx={styles.button}>
            <Typography variant="h3" fontWeight="bold" sx={styles.buttonText}>
              claim
            </Typography>
          </CustomButton>
        </GridItem>
      ))}
    </GridContainer>
  );
};

export default Tiers;
